import { ADD_TO_CART, CALCULATE_PRODUCT_PRICE, CALCULATE_SUB_TOTAL, COUNT_TOTAL, DECREMENT_QUANTITY, REMOVE_FROM_CART } from "./actionTypes"

export const addToCart = (data) => {
    return {
        type: ADD_TO_CART,
        payload: data
    }
}

export const decrementQuantity = (data) => {
    return {
        type: DECREMENT_QUANTITY,
        payload: data
    }
}

export const calculateProductPrice = (product) => {
    return {
        type: CALCULATE_PRODUCT_PRICE,
        payload: product
    }
}

export const calculateSubTotal = () => {
    return {
        type: CALCULATE_SUB_TOTAL,
    }
}

export const countTotal = () => {
    return {
        type: COUNT_TOTAL,
    }
}

export const removeFromCart = (productId) => {
    return {
        type: REMOVE_FROM_CART,
        payload: productId
    }
}